"use client";

import { AccountLink } from "~/components/AccountLink/AccountLink";
import { useIsAuthenticated } from "~/hooks/useIsAuthenticated";

export const AccountIcon = () => {
	const isAuthenticated = useIsAuthenticated();
	return <AccountLink isAuthenticated={isAuthenticated} />;
};
